/** API-key gate. Nothing in the console renders until a key validates. */
import { useState } from 'react';
import { useApi, validateKey } from '../lib/api';
import { Logo } from './Logo';

export default function Gate({ onUnlock }: { onUnlock: () => void }) {
  const { base, token, setConn } = useApi();
  const [b, setB] = useState(base);
  const [k, setK] = useState(token);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function connect() {
    setBusy(true);
    setErr('');
    const trimmed = b.replace(/\/$/, '');
    const r = await validateKey(trimmed, k.trim());
    setBusy(false);
    if (r === 'ok') {
      setConn({ base: trimmed, token: k.trim() });
      onUnlock();
    } else if (r === 'bad') {
      setErr('Invalid API key — the console stays locked.');
    } else {
      setErr('Cannot reach the API at that base URL. Check the address and that the server is up.');
    }
  }

  return (
    <div className="flex h-full items-center justify-center bg-bg p-4">
      <div className="panel w-[380px] p-7" style={{ boxShadow: 'var(--shadow)' }}>
        <div className="mb-1.5 flex items-center gap-2.5">
          <Logo />
          <b className="text-[16px] tracking-wide">CATI-DB Console</b>
        </div>
        <p className="mb-5 text-[12.5px] text-muted">Catalog aggregation · parts, vehicles &amp; cross-data management</p>

        <label className="label mt-3.5">API base</label>
        <input
          className="input mono"
          value={b}
          onChange={(e) => setB(e.target.value)}
          placeholder="leave blank for same origin"
        />
        <label className="label mt-3.5">API key</label>
        <input
          className="input mono"
          type="password"
          value={k}
          autoComplete="off"
          onChange={(e) => setK(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && connect()}
          placeholder="Bearer token"
        />

        <button className="btn btn-primary mt-5 w-full" onClick={connect} disabled={busy}>
          {busy ? 'Connecting…' : 'Connect'}
        </button>
        <div className="mt-2.5 min-h-[16px] text-[12.5px] text-bad">{err}</div>
        <div className="mt-3 border-t border-line pt-3.5 text-[11.5px] text-faint">
          The key is validated against an authenticated endpoint and stored only in this browser. Use <b>Lock</b> to
          forget it.
        </div>
      </div>
    </div>
  );
}
